<template>
  <div class="task"></div>
</template>

<script>
export default {
  name: 'definition-task-refresh',
  props: [
    'refresh',
    'callTask'
  ],
  methods: {
    callRefresh () {
      this.$emit('refreshDefinitionContent')
    }
  },
  watch: {
    refresh (refresh) {
      this.callRefresh()
    }
  }
}
</script>

<style lang="scss">
</style>
